<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M15.25 4.75H4.75C3.92157 4.75 3.25 5.42157 3.25 6.25V8.75C3.25 9.57845 3.92157 10.25 4.75 10.25H15.25C16.0784 10.25 16.75 9.57845 16.75 8.75V6.25C16.75 5.42157 16.0784 4.75 15.25 4.75Z" 
    :stroke="stroke" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.25 14.25H16.75" :stroke="stroke" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.75 15.25C7.44036 15.25 8 14.6904 8 14C8 13.3096 7.44036 12.75 6.75 12.75C6.05964 12.75 5.5 13.3096 5.5 14C5.5 14.6904 6.05964 15.25 6.75 15.25Z" 
    :stroke="stroke" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'VideoLengthIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    stroke: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>

<style scoped></style>